export const makeDetailPageUrl = (path: string, targetId: number) => {
  return path.replace(':id', String(targetId));
};

// RFC 3986: URL 내부에 whitespace 불가. native 파서는 zero-width 문자에서도 자주 크래시.
// ECMAScript \s 는 NBSP(U+00A0), 전각 스페이스(U+3000), BOM(U+FEFF) 을 이미 포함하므로
// zero-width 계열(ZWSP/ZWNJ/ZWJ, U+200B~U+200D) 만 별도로 추가한다.
const LINK_URL_INVISIBLE_PATTERN = new RegExp('[\\s\\u200B-\\u200D]', 'g');

export const normalizeLinkUrl = (raw?: string | null): string =>
  (raw ?? '').replace(LINK_URL_INVISIBLE_PATTERN, '');
